import api from '@/utils/api';

/**
 * Create Company Product
 * @param {string} companyId - the companyId
 * @param {object} data - The category data
 * @returns {Promise}
 */
const createCompanyProductApi = (companyId, data) =>
  api.post(`/company/${companyId}/product`, data);

export default createCompanyProductApi;
